const state = {
  collaboratorsModal: false,
  inviteCollaboratorModal: false,
  addWindowScheduleModal: false,
  createProjectModal: false,
  deleteConfirmationModal: false,
  deleteConfirmationModalTitle: "",
  editProjectModal: false
};

const getters = {
  collaboratorsModal: state => state.collaboratorsModal,
  inviteCollaboratorModal: state => state.inviteCollaboratorModal,
  addWindowScheduleModal: state => state.addWindowScheduleModal,
  createProjectModal: state => state.createProjectModal,
  deleteConfirmationModal: state => state.deleteConfirmationModal,
  deleteConfirmationModalTitle: state => state.deleteConfirmationModalTitle,
  editProjectModal: state => state.editProjectModal
};

const mutations = {
  toggleCollaboratorsModal: state => {
    state.collaboratorsModal = !state.collaboratorsModal;
  },
  toggleInviteCollaboratorModal: state => {
    state.inviteCollaboratorModal = !state.inviteCollaboratorModal;
  },
  toggleAddWindowScheduleModal: state => {
    state.addWindowScheduleModal = !state.addWindowScheduleModal;
  },
  toggleCreateProjectModal: state => {
    state.createProjectModal = !state.createProjectModal;
  },
  toggleDeleteConfirmationModal: (state, payload) => {
    state.deleteConfirmationModalTitle = payload;
    state.deleteConfirmationModal = !state.deleteConfirmationModal;
  },
  toggleEditProjectModal: state => {
    state.editProjectModal = !state.editProjectModal;
  }
};

const actions = {
  toggleCollaboratorsModal: ({ commit }) => {
    commit("toggleCollaboratorsModal");
  },
  toggleInviteCollaboratorModal: ({ commit }) => {
    commit("toggleInviteCollaboratorModal");
  },
  toggleAddWindowScheduleModal: ({ commit }) => {
    commit("toggleAddWindowScheduleModal");
  },
  toggleCreateProjectModal: ({ commit }) => {
    commit("toggleCreateProjectModal");
  },
  toggleDeleteConfirmationModal: ({ commit }, payload) => {
    commit("toggleDeleteConfirmationModal", payload);
  },
  toggleEditProjectModal: ({ commit }) => {
    commit("toggleEditProjectModal");
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
